import { API,Auth } from "aws-amplify";
import { OffLineAPI } from '../offline-auth/api';

var _API = process.env.REACT_APP_isOffline === "true" ? OffLineAPI : API;
let patienthispromise;

export async function createDepartment(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("config", `/department?query=${token}`, {body});
}

export async function getDepartmentList(query){
    // const session = await Auth.currentSession();
    // let token = session.getAccessToken().getJwtToken();
    return _API.get('config', `/department${query}`);
}

export async function updateDepartment(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put('config', `/department?query=${token}`, {body});
}

export async function deleteDepartment(query){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del('config', `/department/${query}?query=${token}`);
}

export async function createSpecialization(body){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post('config', `/specialization?query=${token}`, {body});
}

export async function getSpecialization(query){
    // const session = await Auth.currentSession();
    // let token = session.getAccessToken().getJwtToken();
    return _API.get('config', `/specialization${query}`)
}

export async function updateSpecialization(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put('config', `/specialization?query=${token}`, {body});
}

export async function deleteSpecialization(query){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del('config', `/specialization/${query}?query=${token}`);
}

export async function createDegree(body){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post('config', `/degree?query=${token}`, {body});
}

export function getDegree(query){
    // const session = await Auth.currentSession();
    // let token = session.getAccessToken().getJwtToken();
    return _API.get('config', `/degree${query}`)
}

export async function updateDegree(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put('config', `/degree?query=${token}`, {body});
}

export async function deleteDegree(query){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del('config', `/degree/${query}?query=${token}`);
}

export function DataDefault(body){
    // console.log(body);
    return _API.post('config', `/defaultData`, {body});
}

export async function createTerms(body){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post('config', `/terms?query=${token}`, {body});
}

export async function getTerms(query){
    // const session = await Auth.currentSession();
    // let token = session.getAccessToken().getJwtToken();
    return _API.get('config', `/terms${query}`)
}

export async function updateTerms(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put('config', `/terms?query=${token}`, {body});
}

export async function deleteTerms(query){
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del('config', `/terms${query}?query=${token}`);
}


export async function createNotes(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("config", `/interanlNotes?query=${token}`, { body });
}

export async function getNotes(query) {
    // const session = await Auth.currentSession();
    // let token = session.getAccessToken().getJwtToken();
    return _API.get('config', `/interanlNotes${query}`);
}

export async function updateNotes(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put('config', `/interanlNotes?query=${token}`, { body });
}

export async function deleteNotes(query) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del('config', `/interanlNotes${query}?query=${token}`);
}

export function getNotesData(query) {
    return _API.get('config', `/interanlNotesHistory${query}`);
}

export async function createPatinetMedicalHistory(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.post("config", `/medicalHistory?query=${token}`, { body });
}

export function getPatinetMedicalHistory(query) {
    return _API.get('config', `/medicalHistory${query}`);
}

export async function updatePatinetMedicalHistory(body) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.put('config', `/medicalHistory?query=${token}`, { body });
}

export async function deletePatinetMedicalHistory(query) {
    const session = await Auth.currentSession();
    let token = session.getAccessToken().getJwtToken();
    return _API.del('config', `/medicalHistory${query}?query=${token}`);
}

export function getPatinetMedicalHistoryData(query) {
    if(patienthispromise){
        _API.cancel(patienthispromise,"MY cancelation");
    }
    patienthispromise =_API.get('config', `/patientMedicalHistory${query}`);
    return patienthispromise;
}
export function createSmtpMsg (body){
    return _API.post('config',`/smtp`,{body});
}

export function getSmtpData(){
    return _API.get('config',`/smtp`);
}

export function updateSmtpMsg(body){
    return _API.put('config',`/smtp`,{body});
}

export function deleteSmtp(id){
    return _API.post('config', `/id=${id}`);
}
export function createSms (body){
    return _API.post('config',`/sms`,{body});
}

export function getSmsData(id){
    return _API.get('config',`/sms?clinicId=${id}`);
}

export function updateSmsData(body){
    return _API.put('config',`/sms`,{body});
}

export function deleteSms(id){
    return _API.post('config', `?id=${id}`);
}

export function createTemplate (body){
    return _API.post('config',`/template`,{body});
}

export function getTemplateData(id){
    return _API.get('config',`/sms?templateId=${id}`);
}

export function getTempData(){
    return _API.get('config',`/template`);
}

export function updateTemplate (body,title){
    return _API.put('config',`/template?templateTitle=${encodeURIComponent(title)}`,{body});
}